import { applyBillingFilters } from 'src/app/shared/utils/billing-filter.utils';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IconsService } from 'src/app/shared/services/icons.service';
import { GodModeService } from 'src/app/shared/services/god-mode.service';
import { NgbCalendar, NgbDate, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FullFilterComponent } from 'src/app/components/offcanvas/full-filter.component';
import { Bill } from 'src/app/models/bill.model';
import { Subscription } from 'rxjs';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-unpaid',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Recibos</h1>
      </div>
      <div class="col-md-7 mt-4 text-end">
        
        <!-- button class="btn btn-primary btn-lg rounded-5 ms-3" routerLink="/bills/new">Crear recibo</!-->
      </div>
      <!-- xng-breadcrumb ></!-->
    </div>
    <div class="flex-fill">
      <div class="d-flex">
        <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
          <ul #sidebar app-nav-payments [currentView]="currentView" class="sidebar-zazz list-unstyled">            
            
          </ul>
        </div>

        <div #pages class="flex-fill">

        <div class="d-flex">
          <div>
            <div ngbDropdown class="d-inline-block">
              <button type="button" 
                class="btn btn-zazz-default rounded-4 px-4 shadow-sm" 
                id="dropdownForm1" 
                ngbDropdownToggle>
                <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
                Este mes
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;" (click)="$event.stopPropagation()">
                <div class="row">
                  <div class="col-3">
                    <ul class="list-group calendar-list-group ps-2 mt-2">
                      <li #1day class="list-group-item list-group-item-action active" (click)="updateFilter(1)">Hoy</li>
                      <li #yesterday class="list-group-item list-group-item-action" (click)="updateFilter(0)">Ayer</li>
                      <li #1mes class="list-group-item list-group-item-action" (click)="updateFilter(1)">Este mes</li>
                      <li #3mes class="list-group-item list-group-item-action" (click)="updateFilter(3)">3 meses</li>
                      <li #6mes class="list-group-item list-group-item-action" (click)="updateFilter(6)">6 meses</li>
                      <li #12mes class="list-group-item list-group-item-action" (click)="updateFilter(12)">12 meses</li>
                      <li #custom class="list-group-item list-group-item-action">Personalizado</li>
                    </ul>
                  </div>
                  <div class="col-9" style="height: 320px;">
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input
                        #dpFromDate
                        class="form-control"
                        style="width: 0px !important; height: 0px !important; opacity: 0;"
                        ngbDatepicker
                        #datepicker="ngbDatepicker"
                        [autoClose]="false"
                        (dateSelect)="onDateSelection($event)"
                        [displayMonths]="2"
                        [dayTemplate]="t"
                        outsideDays="hidden"
                        [startDate]="fromDate!"
                        tabindex="-1" 
                      />
                      <ng-template #t let-date let-focused="focused">
                          <span
                            class="custom-day"
                            [class.focused]="focused"
                            [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)"
                            [class.selected]="date.equals(fromDate) || (toDate && date.equals(toDate))"
                            (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null"
                          >
                            {{ date.day }}
                          </span>
                        </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-fill">
            <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openFilters()">
              <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
              Filtrar búsqueda
            </button>
            <button class="btn btn-outline-secondary rounded-4 px-4 ms-2 shadow-sm" (click)="resetFilters()">
              <fa-icon [icon]="icons.faRotateLeft" class="me-2"></fa-icon>
              Limpiar filtros
            </button>
          </div>
          <div class="flex-fill ms-2">
            <!-- input type="text" class="form-control rounded-4 border border-1 border-secondary" placeholder="Buscar recibo" formControlName="search" -->
          </div>
        </div>

        <div class="flex-fill list-group rounded-5 shadow mt-4" >          
          <div class="list-group-item" *ngIf="bills.length > 0">
            <table class="table table-sm">
              <thead class="thead-dark">
                <tr class="">
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3"># Recibo <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Unidad </th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Razón social</th>
                  <!-- th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Consumo</th -->
                  <th scope="col" *ngIf="payFilterPrefs.status" class="text-center bg-zazz align-items-center align-middle text-light py-2">Pago <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                  <th scope="col" *ngIf="!payFilterPrefs.status" class="text-center bg-zazz align-items-center align-middle text-light py-2">Total a pagar <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Vence <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Fin periodo <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Estatus</th>
                  <th scope="col" class="bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr app-tr-payments 
                    [bill]="bill"
                    [showLegalEntity]="true"
                  [profile]="profile" 
                  [permissions]="permissions"
                  (updateDate)="updateBillDate($event)"
                  *ngFor="let bill of bills | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                ></tr>
              </tbody>
            </table>
          </div>
          <div class="list-group-item" *ngIf="bills.length==0&&loading">
          <div class="text-center py-5">
            <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
            <p class="text-muted">Cargando...</p>
          </div>
          </div>
          <div class="list-group-item" *ngIf="bills.length==0&&!loading">
            <div class="text-center py-5">
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">No se encontraron registros</p>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            ></pagination-controls>
          </div>
        </div>
      </div>
  `,
  styleUrls: []
})
export class UnpaidComponent implements OnInit, OnDestroy {
  bills: Bill[] = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};
  godmode: boolean = false;

  selectedBill: any = null;

  @ViewChild('1day') oneDay !: ElementRef;
  @ViewChild('yesterday') yesterday !: ElementRef;
  @ViewChild('1mes') oneMonth !: ElementRef;
  @ViewChild('3mes') threeMonth !: ElementRef;
  @ViewChild('6mes') sixMonth !: ElementRef;
  @ViewChild('12mes') twelveMonth !: ElementRef;
  @ViewChild('custom') custom !: ElementRef;
  @ViewChild('datepicker') datepicker: any;
  
  searchBox: FormGroup = new FormGroup({});
  loading: boolean = false;
  currentView: string = 'receipts';

  payload: any = {    
    page: 1,
    per_page: 50,
    status: false,
    state: 0,
    sort: 'created_at',
    order: 'DESC'
  };

  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate: NgbDate | null;

  p: number = 1;
  units: any = [];

  payFilterPrefs: any = {};
  hoveredDate: NgbDate | null = null;

  private godModeSubscription: Subscription = new Subscription();
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    private godModeService: GodModeService,
    private offcanvasService: NgbOffcanvas,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.godmode = this.godModeService.getGodMode();

    const adjustedDate = new Date(this.a.getFullYear(), this.a.getMonth(), this.a.getDate());
    const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;

    this.payFilterPrefs = this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) ? this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) : this.payload;
    this.payFilterPrefs.state = 0;
    if (!this.godmode) {
      this.payFilterPrefs.profile_id = this.profile.id; // Set profile_id for non-godmode users
    } else {
      delete this.payFilterPrefs.profile_id;
    }
    this.payFilterPrefs.status = false;
    this.payFilterPrefs.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payFilterPrefs.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
    this.payFilterPrefs.sort = 'created_at';
    this.payFilterPrefs.order = 'DESC';
    this.payFilterPrefs.all = true;
    this.p = this.payFilterPrefs.page;

    this.loadBills(this.payFilterPrefs);
  }

  onDropdownClick(event: Event) {
    event.stopPropagation();
  }

  ngOnInit(): void {
    // Subscribe to god mode changes
    this.godModeSubscription = this.godModeService.godMode$.subscribe(
      (godMode: boolean) => {
        this.godmode = godMode;
        // Update payFilterPrefs based on god mode
        if (!this.godmode) {
          this.payFilterPrefs.profile_id = this.profile.id;
        } else {
          delete this.payFilterPrefs.profile_id;
        }
        // Reload bills when god mode changes
        this.loadBills(this.payFilterPrefs);
      }
    );

    setTimeout(() => {
      this.datepicker.open();
    });
  }

  ngOnDestroy(): void {
    this.godModeSubscription.unsubscribe();
  }

  updateDate(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;

    if (this.toDate?.after(this.fromDate) || this.toDate?.equals(this.fromDate)) {
      this.payFilterPrefs.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
      this.payFilterPrefs.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
      this.loadBills(this.payFilterPrefs);
    }
  }

  loadBills(payload: any) {
    this.loading = true;
    this.bills = [];
    this.store.getBillsQuery(payload).subscribe({
      next: (data: any) => {
        this.bills = data.data;
        this.meta = data.meta;
        this.loading = false;
        this.storageService.saveItem(STORAGE_KEYS.PAYFILTERSPREFS, this.payFilterPrefs);
      }, error: (err: any) => {
        this.loading = false;
      }
    });
  }

  deleteBill(bill: any) {
    let confirmation = confirm('¿Está seguro de eliminar el recibo?');
    if (!confirmation) {
      return;
    } else {
      this.store.destroyBill(bill.id).subscribe({
        next: (data: any) => {
          this.toastr.success('Recibo eliminada correctamente', 'Éxito');
          this.loadBills(this.payload);
        },
        error: (err: any) => {
          this.toastr.error('Ocurrió un error al eliminar el recibo', 'Error');
        }
      });
    }
  }

  loadBillsBySettlement(settlement_id: any) {
    this.payFilterPrefs.settlement_id = settlement_id;    
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadBills(this.payFilterPrefs);   
  }

  loadBillsByBuilding(building_id: any) {
    this.payFilterPrefs.building_id = building_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadBills(this.payFilterPrefs);
  }

  loadBillsByFloor(floor_id: any) {
    this.payFilterPrefs.floor_id = floor_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.unit_id;

    this.loadBills(this.payFilterPrefs);
  }

  loadBillsByUnit(unit_id: any) {
    this.payFilterPrefs.unit_id = unit_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;
    this.loadBills(this.payFilterPrefs);
  }

  loadBillsSort(event: any) {
    this.payFilterPrefs.sort = event;
    this.loadBills(this.payFilterPrefs);
  }

  loadBillsOrder(event: any) {
    this.payFilterPrefs.order = event;
    this.loadBills(this.payFilterPrefs);
  }

  loadBillsPerPage(event: any) {
    this.payFilterPrefs.per_page = parseInt(event);
    this.loadBills(this.payFilterPrefs);
  }

  clearFilter() {
    delete this.payFilterPrefs.legal_entity_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.settlement_id;
    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadBills(this.payFilterPrefs);
  }

  pageChanged(event: any) {
    this.payFilterPrefs.page = event;
    this.loadBills(this.payFilterPrefs);
  }

  updateBillDate(event: any) {
    this.selectedBill = event;
    // new bs.Modal(<HTMLInputElement>document.getElementById('modalSetBillDate')).show();
  }

  openFilters() {
    const offcanvasRef = this.offcanvasService.open(FullFilterComponent, {
      position: 'end',
      animation: true,
      backdrop: true,
      keyboard: true,
      scroll: true,
      backdropClass: 'bg-dark',
      panelClass: 'bg-light',
    });

    offcanvasRef.componentInstance.payload = this.payFilterPrefs;
    offcanvasRef.componentInstance.profile = this.profile;
    offcanvasRef.componentInstance.showLegalEntity = true;
    offcanvasRef.result.then((result: any) => {
      this.payFilterPrefs = applyBillingFilters(this.payFilterPrefs, result);
      this.p = 1;
      if (!this.godmode) this.payFilterPrefs.profile_id = this.profile.id;
      else delete this.payFilterPrefs.profile_id;
      this.payFilterPrefs.all = true;
      this.payFilterPrefs.state = 0;
      this.loadBills(this.payFilterPrefs);
    });
  }

  resetFilters() {
    const adjustedDate = new Date(this.a.getFullYear(), this.a.getMonth(), this.a.getDate());
    const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());
    // Reset to initial payload values
    this.payFilterPrefs = {
      page: 1,
      per_page: 50,
      status: false,
      state: 0,
      sort: 'created_at',
      order: 'DESC',
      profile_id: this.profile.id,
      all: true,
      created_at_since: this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day,
      created_at_to: this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day
    };

    if (!this.godmode) {
      this.payFilterPrefs.profile_id = this.profile.id; // Set profile_id for non-godmode users
    } else {
      delete this.payFilterPrefs.profile_id;
    }

    // Remove any additional filters
    delete this.payFilterPrefs.settlement_id;
    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    // Reset page
    this.p = 1;

    // Reset active states on filter buttons
    this.oneDay?.nativeElement.classList.remove('active');
    this.yesterday?.nativeElement.classList.remove('active');
    this.oneMonth?.nativeElement.classList.add('active');
    this.threeMonth?.nativeElement.classList.remove('active');
    this.sixMonth?.nativeElement.classList.remove('active');
    this.twelveMonth?.nativeElement.classList.remove('active');
    this.custom?.nativeElement.classList.remove('active');

    // Update localStorage
    this.storageService.saveItem(STORAGE_KEYS.PAYFILTERSPREFS, this.payFilterPrefs);

    // Reload bills with reset filters
    this.loadBills(this.payFilterPrefs);
  }

  updateFilter(mes: number) {
    setTimeout(() => {
      this.datepicker.open();
    });

    if (mes === 0) {
      // Handle yesterday
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      
      this.fromDate = new NgbDate(yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      this.toDate = new NgbDate(yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      
      // Update active states
      this.oneDay.nativeElement.classList.remove('active');
      this.yesterday.nativeElement.classList.add('active');
      this.oneMonth.nativeElement.classList.remove('active');
      this.threeMonth.nativeElement.classList.remove('active');
      this.sixMonth.nativeElement.classList.remove('active');
      this.twelveMonth.nativeElement.classList.remove('active');
      this.custom.nativeElement.classList.remove('active');
    } else {
      const today = new Date();
      today.setMonth(today.getMonth() - mes);
      const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

      this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
      this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

      this.payFilterPrefs.created_at_since = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
      this.payFilterPrefs.created_at_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;

      this.loadBills(this.payFilterPrefs);

      if (mes == 1) {
        this.oneMonth.nativeElement.classList.add('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 3) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.add('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 6) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.add('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 12) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.add('active');
        this.custom.nativeElement.classList.remove('active');
      }
    }
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date) {
      this.toDate = date;
      if (this.fromDate.after(this.toDate)) {
        // If fromDate is after toDate, swap them
        const temp = this.fromDate;
        this.fromDate = this.toDate;
        this.toDate = temp;
      }
		} else {
			this.toDate = null;
			this.fromDate = date;
		}

    if (this.fromDate && this.toDate) {
      this.payFilterPrefs.created_at_since = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
      this.payFilterPrefs.created_at_to = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
      this.payFilterPrefs.page = 1;
      this.payFilterPrefs.state = 0;
      this.loadBills(this.payFilterPrefs);
    }
	}

	isHovered(date: NgbDate) {
    return (
      this.fromDate && 
      !this.toDate && 
      this.hoveredDate && 
      date.after(this.fromDate) && 
      date.before(this.hoveredDate)
    );
  }

    isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && 
          date.after(this.fromDate) && 
          date.before(this.toDate);
  }

}
